export default class AcompanhamentoCargaFOBParameters
{
    idFornecedor : number = 0;
    pedido : number = 0;
    item : number = 0;
    skus : number[] = [];
   // public List<string>? Contrato { get; set; }
}